const moment = require('moment');
const d3 = require('d3');
const i18n = require('core/i18n').i18n;
const { getCurrencySymbol, formatAmount, getFormattedAmount } = require('utilities/currencyHelper');
const { DATE_PICKER_CUSTOM_LOCALE } = require('constants/commonsComponents');
const es_ES = {
    'decimal': '.',
    'thousands': ',',
    'grouping': [3],
    'currency': ['$', ''],
    'dateTime': '%a %b %e %X %Y',
    'date': '%m/%d/%Y',
    'time': '%H:%M:%S',
    'periods': ['AM', 'PM'],
    'days': ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    'shortDays': ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
    'months': ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    'shortMonths': ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
};
const en_US = {
    'decimal': '.',
    'thousands': ',',
    'grouping': [3],
    'currency': ['\$', ''],
    'dateTime': '%a %b %e %X %Y',
    'date': '%m/%d/%Y',
    'time': '%H:%M:%S',
    'periods': ['AM', 'PM'],
    'days': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    'shortDays': ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    'months': ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    'shortMonths': ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
};

const decideAxisDateLabel = (maxDate, minDate) => {
    const datePickerLanguage = i18n.formatText(DATE_PICKER_CUSTOM_LOCALE);
    const diffDays = maxDate.diff(minDate, 'days');
    let loc;

    if (datePickerLanguage === 'es') {
        loc = d3.locale(es_ES);
    } else if (datePickerLanguage === 'en') {
        loc = d3.locale(en_US);
    } else {
        loc = d3.locale(en_US);
    }

    if (diffDays < 32) {
        return loc.timeFormat('%d %b');
    } else if (diffDays > 31 && diffDays < 360) {
        return loc.timeFormat('%b %Y');
    } else {
        return loc.timeFormat('%b %Y');
    }
};

const yAxisFormatLabel = (d) => {
    const moneyObj = { amount: d, currency: "EUR" }; // @harcoded response has no currency
    const curr = getCurrencySymbol(moneyObj);
    const amount = formatAmount(d);

    return `${amount} ${curr}`;
};

const createTooltip = (d) => {
    const locMoment = moment(d.historicalDate).locale(DATE_PICKER_CUSTOM_LOCALE);
    const formattedDate = locMoment.format('D MMM YYYY');
    const moneyObj = { amount: d.total, currency: "EUR" };// @harcoded response has no currency
    const fa = getFormattedAmount(moneyObj);
    const fs = getCurrencySymbol(moneyObj);

    return `${formattedDate} <span>${fa} ${fs}</span>`;
};

const createTopText = lastData => {
    const moneyObj = {
        amount: lastData.total,
        currency: "EUR" // @harcoded response has no currency
    };
    const fa = getFormattedAmount(moneyObj);
    const fs = getCurrencySymbol(moneyObj);
    const todayText = i18n.formatText('myWallet-today');

    return `<span>${todayText}</span>\
        <span>${fa} ${fs}</span>`;
};

const dateTicks = (min, max) => {
    const monthsDiff = max.month() - min.month();
    /**
     * TODO fix here if we want to set manual the ticks with .tickValues()
     * 2 is for the extremes
     */

    return monthsDiff + 2;
};

module.exports = {
    decideAxisDateLabel,
    yAxisFormatLabel,
    createTooltip,
    createTopText,
    dateTicks
};
